import DashboardLayout from "../../layouts/Dashboard";
import FormAttributeMappingCRUDTable from "../../components/CRUD/Tables/FormAttributeMappingCRUDTable";
import {useHistory} from "react-router-dom";
import useReload from "../../hooks/useReload";
import {FORM_ATTRIBUTE_MAPPING_DETAIL_ROUTE} from "../../routes";
import {formAttributeMappingCRUD} from "../../http";

const FormAttributeMappingList = ()=>{
    const history = useHistory()
    const {reload, reloadValue} = useReload();

    const detailAction =(id)=>{
        history.push(FORM_ATTRIBUTE_MAPPING_DETAIL_ROUTE(id),{
            review:true
        })
    }

    const editAction =(id)=>{
        history.push(FORM_ATTRIBUTE_MAPPING_DETAIL_ROUTE(id),{
            review:false
        })
    }

    const deleteAction =async(id)=> {
        try {
            await formAttributeMappingCRUD.delete(id)
            reload()
        } catch (err) {

        }
    }
    return <DashboardLayout>
        <FormAttributeMappingCRUDTable onClickDetailsButton={detailAction}
                           onClickDeleteButton={deleteAction}
                           onClickEditButton={editAction} reloadValue={reloadValue} />
    </DashboardLayout>
}

export default FormAttributeMappingList 